export const version = "1.7.20";
export const channel = "release";
export const gitcommit = "b4ccc8922";
